import styled from '@emotion/styled'

import { CONFIG } from '@/styles/emotion.config'

export const ModalContentStyles = styled.div`
  position: relative;
  margin: 0.5rem;
  padding: 2rem 1.5rem;
  border-radius: 1.5rem;
  border: 1px solid rgb(212, 218, 224); // silver
  background-color: #000;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08);

  width: calc(100% - 3rem);
  max-width: 45.5rem;
  max-height: calc(100% - 5rem);
  -webkit-overflow-scrolling: touch;

  .modal-header {
    padding-bottom: 1rem;
    text-align: left;
  }

  .modal-title {
    font-size: 1.5rem;
    font-weight: bold;
    line-height: 1.75rem;
    letter-spacing: -0.8px;
    margin-right: 4rem;
  }

  .modal-close {
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;
    padding: 0.5em;
    line-height: 1;
    border: none;
    box-shadow: none;
    cursor: pointer;
    background-color: transparent;
    transition: filter 0.2s ease-in-out;
    &:hover {
      filter: brightness(0.9);
    }
    svg {
      width: 1.5rem;
      height: 1.5rem;
      fill: #fff;
    }
  }

  .modal-subtitle {
    font-size: 1rem;
    font-weight: normal;
    line-height: 1.5rem;
  }

  ${CONFIG.media.mobileMd} {
    width: calc(100% - 1.5rem);
    max-width: 18.75rem;
    max-height: 27.75rem;
    .modal-close {
      top: 1.75rem;
    }
  }

  .cta-wrapper {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .cta {
      background-color: rgb(var(--colors-pink));
      transition: filter 0.2s ease-in-out;
      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`
